import { isServer } from 'utils/constants';
import { ShipmentMethod } from '__generated__/graphql';

export const transformShipmentMethod = (
  method: ShipmentMethod
): ApplePayJS.ApplePayShippingMethod => ({
  label: method.name as string,
  amount: method.price?.toString() as string,
  identifier: method.id as string,
  detail: method.id,
});

export const ensureAddressFields = (
  address: ApplePayJS.ApplePayPaymentContact | undefined
): boolean => {
  return !!(
    address &&
    address.administrativeArea &&
    address.countryCode &&
    address.familyName &&
    address.givenName &&
    address.locality &&
    address.postalCode &&
    address.addressLines &&
    address.addressLines[0]
  );
};

export const hasAllFieldsForTaxCalculation = (
  event: ApplePayJS.ApplePayShippingContactSelectedEvent
) => {
  return !(
    !event.shippingContact.locality ||
    !event.shippingContact.postalCode ||
    !event.shippingContact.administrativeArea ||
    !event.shippingContact.countryCode
  );
};

// NOTE: How to introduce conditional logic in mocks.
if (!isServer && process.env.NEXT_PUBLIC_GQL_MOCKS === 'true') {
  // NOTE: `canMakePayments` needs to return `true`. Only then we are able to
  // render it.
  window.ApplePaySession = {
    // @ts-expect-error
    canMakePayments() {
      return true;
    },
    supportsVersion() {
      return true;
    },
  };
}

export const canStartAppleSheet =
  process.env.NEXT_PUBLIC_GQL_MOCKS === 'true'
    ? !isServer
    : !isServer &&
      window.location.href.startsWith('https') &&
      !!(window as any).ApplePaySession;
